import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const Fritidshus = lazy(() => import("@/pages/elavtal/Fritidshus"));

export const Route = createFileRoute("/elavtal/fritidshus")({
  head: () => seoHead("/elavtal/fritidshus", { description: "Ett fritidshus har låg och ojämn förbrukning. Välj ett avtal utan höga fasta avgifter för att hålla nere kostnaden." }),
  component: () => <Fritidshus />,
});
